import React from "react"
import { BadgeProps } from "@mui/material"
import { faCheck, faTimes, faInfo } from "@fortawesome/pro-solid-svg-icons"
import { BadgeIcon, StyledBadge } from "./styles"
import { NeutralSetting } from "src/types"

export interface ReviewBadgeProps extends BadgeProps {
  correct?: boolean
  groupMode?: boolean
  badgeBorder?: boolean
  isNeutralSetting?: NeutralSetting
}

export type ReviewBadgeOrigin =
  | "topLeft"
  | "topRight"
  | "bottomLeft"
  | "bottomRight"

export const REVIEW_BADGE_ORIGIN: Record<
  ReviewBadgeOrigin,
  BadgeProps["anchorOrigin"]
> = {
  topLeft: { vertical: "top", horizontal: "left" },
  topRight: { vertical: "top", horizontal: "right" },
  bottomLeft: { vertical: "bottom", horizontal: "left" },
  bottomRight: { vertical: "bottom", horizontal: "right" }
}

export const ReviewBadge = React.forwardRef<HTMLSpanElement, ReviewBadgeProps>(
  (
    {
      correct,
      badgeBorder = false,
      groupMode = false,
      isNeutralSetting,
      ...props
    },
    ref
  ) => {
    if (groupMode) {
      return (
        <StyledBadge
          ref={ref}
          badgeContent={<BadgeIcon icon={faInfo} />}
          color="info"
          badgeBorder={false}
          {...props}
        />
      )
    }

    return (
      <StyledBadge
        ref={ref}
        invisible={
          correct === undefined || correct === null || isNeutralSetting
        }
        badgeContent={<BadgeIcon icon={correct ? faCheck : faTimes} />}
        color={correct ? "success" : "warning"}
        badgeBorder={badgeBorder}
        {...props}
      />
    )
  }
)
